export enum RegimeBem {
  COMUNHAO_PARCIAL = 'COMUNHAO_PARCIAL',
  COMUNHAO_UNIVERSAL = 'COMUNHAO_UNIVERSAL',
  SEPARACAO_TOTAL = 'SEPARACAO_TOTAL',
  PARTICIPACAO_FINAL_AQUESTOS = 'PARTICIPACAO_FINAL_AQUESTOS',
}
